<template>
  <div>
    <andes-header></andes-header>

    <div class="container">
      <div class="row">
        <div class="col">
          <h5>Vuelo O4 {{checkinFlight.Legs[0].InventoryLeg.FlightNumber}} <strong>{{checkinFlight.DepartureStation}}
            <img src="@/img/plane-32.png" alt="Flying to">
            {{checkinFlight.ArrivalStation}}</strong> {{getFormatDate}}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <seatmap-plane
            :seat-map="seatMapDictionary"
            :prices="prices"
            :sales-mode="true"
            :current-pax="currentPax"
            @assignSeat="assignSeat"
            @seatHover="onSeatHover"
          ></seatmap-plane>
        </div>
        <div class="col-12 col-md-6 seat-info-box">
          <seat-overlay-information :information="information"></seat-overlay-information>
          <seat-select-passenger
            class="mt-3"
            :paxs="paxs"
            :current-pax="currentPax"
            :prices="prices"
            @select-pax="onSelectPax"
            @clear-seat="clearSeat"
          ></seat-select-passenger>
          <div class="mt-3">
            <button type="button" class="btn btn-outline-secondary btn-block" :disabled="!currentPax || saving" @click="assignRandomSeat">
              Asignar asiento aleatorio
            </button>
            <button
              v-if="canClearCurrent"
              type="button"
              class="btn btn-outline-danger btn-block mt-2"
              :disabled="saving"
              @click="clearSeat(currentPax)"
            >
              {{ $t('Cancelar asiento') }}
            </button>
          </div>
          <div class="alert alert-warning mt-3 mb-0" v-if="seatBalanceDue > 0">
            Cargo de asiento pendiente: ARS {{formatAmount(seatBalanceDue)}}. Al continuar deberás pagar antes de finalizar el check-in.
          </div>
          <hr>
          <seatmap-references/>
          <div class="row mt-3">
            <div class="col-6">
              <button type="button" class="btn btn-link" @click="onCancelChanges">{{ $t('Cancelar Cambios') }}</button>
            </div>
            <div class="col-6 text-right">
              <button type="button" class="btn btn-continue" @click="onContinue">{{ $t('Continuar') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <andes-footer></andes-footer>
    <loading-modal v-if="loading"></loading-modal>
  </div>
</template>

<script>
  import moment from 'moment';
  import {
    getSeatMap,
    postAssignSeat,
    removeAssignSeat,
    postRandomSeat,
    getCheckinSeatPrices,
  } from '@/api/api';
  import {mapState} from 'vuex';
  import AndesHeader from "../components/AndesHeader";
  import AndesFooter from "../components/AndesFooter";
  import LoadingModal from "../components/LoadingModal";
  import SeatOverlayInformation from "../components/seatmap/SeatOverlayInformation";
  import SeatSelectPassenger from "../components/seatmap/SeatSelectPassenger";
  import SeatmapPlane from "../components/seatmap/Seatmap";
  import SeatmapReferences from "../components/seatmap/SeatmapReferences";
  import {formatMoney, bookingHasCharterFlight} from "../utils/utils";

  export default {
    name: "SeatMapPage",
    components: {
      SeatmapReferences,
      SeatmapPlane,
      SeatSelectPassenger, SeatOverlayInformation, LoadingModal, AndesFooter, AndesHeader
    },
    computed: {
      ...mapState(['booking', 'loading', 'checkinFlight', 'segmentsToCheck']),
      getFormatDate: function () {
        return moment(this.checkinFlight.DepartureDate).locale('es').format('DD MMMM YYYY')
      },
      paxs: function () {
        var list = [];
        for (var segmentId of this.segmentsToCheck) {
          for (var pax of this.booking.Passengers) {
            for (var seg of pax.Segments) {
              if (seg.SegmentID == segmentId) {
                list.push({'pax': pax, 'segId': segmentId, 'segment': seg, 'paxLeg': seg.Legs[0]});
              }
            }
          }
        }
        return list
      },
      isCharterFlight: function () {
        if (this.checkinFlight && this.checkinFlight.IsCharter) return true;
        if (this.checkinFlight && this.checkinFlight.Legs && this.checkinFlight.Legs[0]
            && this.checkinFlight.Legs[0].InventoryLeg && this.checkinFlight.Legs[0].InventoryLeg.IsCharter) {
          return true;
        }
        return bookingHasCharterFlight(this.booking);
      },
      seatBalanceDue: function () {
        if (this.isCharterFlight) return 0;
        return parseFloat(this.booking.BalanceDue || 0);
      },
      canClearCurrent: function () {
        if (!this.currentPax || !this.currentPax.paxLeg || !this.currentPax.paxLeg.UnitDesignator) {
          return false;
        }
        let fees = this.currentPax.segment && this.currentPax.segment.Fees;
        if (!fees || !fees.length) return true;
        let isSeatFee = (fee) => Number(fee.FeeType) === 9 || (fee.Fee && Number(fee.Fee.FeeType) === 9)
          || fee.FeeCode === 'SEAT' || (fee.Fee && fee.Fee.FeeCode === 'SEAT');
        let hasUnpaid = fees.some((fee) => isSeatFee(fee) && !fee.PaymentID);
        if (hasUnpaid) return true;
        let hasPaid = fees.some((fee) => isSeatFee(fee) && fee.PaymentID);
        return !hasPaid;
      },
    },
    data: function () {
      return {
        information: "",
        seatMapDictionary: {},
        prices: {},
        currentPax: null,
        balanceType: null,
        saving: false,
        originalSeats: {},
      }
    },
    methods: {
      formatAmount: function (amount) {
        return formatMoney(amount);
      },
      syncCurrentPax: function () {
        let list = this.paxs;
        if (!list.length) {
          this.currentPax = null;
          return;
        }
        if (this.currentPax) {
          let found = _.find(list, (item) =>
            item.pax.PassengerID === this.currentPax.pax.PassengerID && item.segId === this.currentPax.segId
          );
          if (found) {
            this.currentPax = found;
            return;
          }
        }
        this.currentPax = list[0];
      },
      rememberOriginalSeats: function () {
        this.originalSeats = {};
        for (let item of this.paxs) {
          this.originalSeats[item.segId + '-' + item.pax.PassengerID] = item.paxLeg.UnitDesignator || null;
        }
      },
      getOriginalSeat: function (paxToChange) {
        return this.originalSeats[paxToChange.segId + '-' + paxToChange.pax.PassengerID] || null;
      },
      applyAssignResult: function (result) {
        if (result.Booking) {
          this.$store.dispatch('updateBooking', result.Booking);
        }
        if (result.SeatMap) {
          this.seatMapDictionary = result.SeatMap[this.checkinFlight.Legs[0].InventoryLegID] || result.SeatMap;
        }
        this.$nextTick(() => {
          this.syncCurrentPax();
        });
      },
      assignSeat: function (pax, seat) {
        if (!pax || this.saving) return;
        let params = {
          'RecordLocator': this.booking.RecordLocator,
          'UnitDesignator': seat,
          'LegNumber': pax.paxLeg.LegNumber,
          'SegmentID': pax.segId,
          'FlightId': pax.paxLeg.InventoryLeg.FlightId,
          'ChargeSeatFee': !this.isCharterFlight,
        }
        this.saving = true;
        this.$store.commit('loading', true);
        postAssignSeat(params, (result) => {
          this.applyAssignResult(result);
          this.nextPassenger();
          this.saving = false;
          this.$store.commit('loading', false);
        }, (error) => {
          this.saving = false;
          this.$store.commit('loading', false);
          alert(error);
        })
      },
      assignRandomSeat: function () {
        if (!this.currentPax || this.saving) return;
        let pax = this.currentPax;
        let params = {
          'RecordLocator': this.booking.RecordLocator,
          'LegNumber': pax.paxLeg.LegNumber,
          'SegmentID': pax.segId,
          'FlightId': pax.paxLeg.InventoryLeg.FlightId,
          'ChargeSeatFee': !this.isCharterFlight,
        };
        this.saving = true;
        this.$store.commit('loading', true);
        postRandomSeat(params, (result) => {
          this.applyAssignResult(result);
          this.nextPassenger();
          this.saving = false;
          this.$store.commit('loading', false);
        }, (error) => {
          this.saving = false;
          this.$store.commit('loading', false);
          alert(error);
        });
      },
      nextPassenger: function () {
        let list = this.paxs;
        let index = _.findIndex(list, (item) =>
          this.currentPax
          && item.pax.PassengerID === this.currentPax.pax.PassengerID
          && item.segId === this.currentPax.segId
        );
        if (index >= 0 && index < list.length - 1) {
          this.currentPax = list[index + 1];
        }
      },
      onCancelChanges: function () {
        for (var pax of this.paxs) {
          var currentSeat = pax.paxLeg.UnitDesignator;
          var originalSeat = this.getOriginalSeat(pax);
          if (currentSeat != originalSeat) {
            if (originalSeat != null) {
              this.assignSeat(pax, originalSeat);
            } else {
              this.removeSeat(pax);
            }
          }
        }
        this.$router.replace('itinerary');
      },
      removeSeat: function (pax) {
        let params = {
          'RecordLocator': this.booking.RecordLocator,
          'LegNumber': pax.paxLeg.LegNumber,
          'FlightId': pax.paxLeg.InventoryLeg.FlightId,
          'SegmentID': pax.segId
        }
        removeAssignSeat(params, (result) => {
          this.applyAssignResult(result);
        })
      },
      clearSeat: function (pax) {
        if (!pax || this.saving) return;
        if (!pax.paxLeg || !pax.paxLeg.UnitDesignator) return;
        this.saving = true;
        this.$store.commit('loading', true);
        let params = {
          'RecordLocator': this.booking.RecordLocator,
          'LegNumber': pax.paxLeg.LegNumber,
          'FlightId': pax.paxLeg.InventoryLeg.FlightId,
          'SegmentID': pax.segId
        };
        removeAssignSeat(params, (result) => {
          this.applyAssignResult(result);
          this.saving = false;
          this.$store.commit('loading', false);
        }, (error) => {
          this.saving = false;
          this.$store.commit('loading', false);
          alert(error);
        });
      },
      onContinue: function () {
        let list = this.paxs;
        let missing = _.find(list, (item) => !item.paxLeg || !item.paxLeg.UnitDesignator);
        if (missing) {
          this.currentPax = missing;
          alert(this.$t('Asigná un asiento a todos los pasajeros o usá asiento aleatorio.'));
          return;
        }
        this.$store.commit('updateSeats', this.paxs);
        if (this.seatBalanceDue > 0) {
          this.$store.commit('afterPaymentRoute', 'checkinreview');
          this.$router.replace('payment-pending');
          return;
        }
        this.$router.replace('checkinreview');
      },
      onSelectPax: function (value) {
        this.currentPax = value;
      },
      onSeatHover: function (text) {
        this.information = text || '';
      },
      loadPrices: function () {
        if (!this.paxs.length) return;
        let segmentId = this.paxs[0].segId;
        getCheckinSeatPrices({
          RecordLocator: this.booking.RecordLocator,
          SegmentID: segmentId,
        }, (result) => {
          this.prices = (result && result.Prices) || {};
          if (result && result.Booking) {
            this.$store.dispatch('updateBooking', result.Booking);
          }
        }, () => {
          this.prices = {};
        });
      },
      balanceSeatmap: function () {
        if (this.balanceType == null || this.balanceType == 'none') {
          return;
        }

        var min = 1;
        var max = 13;
        if (this.balanceType == 'block_back') {
          min = 24;
          max = 32;
        }

        for (let row=min; row<max; row++ ) {
          for (let column of ['A', 'B' ,'C', 'D', 'E', 'F']) {
            let unitDesignator = row + column;
            if (this.seatMapDictionary.hasOwnProperty(unitDesignator)) {
              this.seatMapDictionary[unitDesignator].Status = 'UNAVAILABLE';
            }
          }
        }
      }
    },
    mounted() {
      if (_.isEmpty(this.booking)) {
        this.$router.replace('/');
        return;
      }

      this.syncCurrentPax();
      this.rememberOriginalSeats();
      this.$store.commit('loading', true);
      let legIDs = [];
      for (let leg of this.checkinFlight.Legs) {
        legIDs.push(leg.InventoryLegID)
      }
      getSeatMap(legIDs, (seatMapDictionary) => {
        this.seatMapDictionary = seatMapDictionary;
        this.loadPrices();
        this.$store.commit('loading', false);
      });
    },
    watch: {
      seatMapDictionary: function () {
        if (this.balanceType != null) {
          this.balanceSeatmap();
          return;
        }
        let frontPassengers = 0;
        let backPassengers = 0;
        for (var row=1; row<32; row++ ) {
          for (var column of ['A','B', 'C','D', 'E', 'F']) {
            let unitDesignator = row + column;
            if (this.seatMapDictionary.hasOwnProperty(unitDesignator)) {
              let seat = this.seatMapDictionary[unitDesignator];
              if (seat.Status !== 'AVAILABLE' ) {
                if (row <= 12) {
                  frontPassengers += 1;
                }
                if (row >= 24) {
                  backPassengers += 1;
                }
              }
            }
          }
        }

        if (frontPassengers - backPassengers >= 6) {
          this.balanceType = 'block_front';
        } else if (backPassengers - frontPassengers >= 6) {
          this.balanceType = 'block_back';
        } else {
          this.balanceType = 'none';
        }

        this.balanceSeatmap();
      },
      booking: function () {
        this.syncCurrentPax();
      }
    }
  }
</script>
